module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-03-10 at 4.44.49 PM.fbe68c24.jpeg";